// extracted by mini-css-extract-plugin
module.exports = {"main":"TableCells_main__1XLX_","list":"TableCells_list__zn9li","firstItemBold":"TableCells_firstItemBold__1BEQn","link":"TableCells_link__36pwP"};